import { useGLTF } from "@react-three/drei";
import { useBox } from "@react-three/cannon";

const BEE_URL = "/kai/orange-space-mascot.glb";
const BEE_SCALE = 5 * (2 / 3);

// Approximate bounding box of the Kai mascot at BEE_SCALE
// (width, height, depth) in world units
const COLLIDER_W = 1.2;
const COLLIDER_H = 2.2;
const COLLIDER_D = 1.2;

export default function Bee({ position, rotation }: { position: [number, number, number]; rotation?: [number, number, number] }) {
	const bee = useGLTF(BEE_URL);

	// Static physics collider centred on the model (sits on y=position[1], so offset up by half height)
	const [colliderRef] = useBox(() => ({
		mass: 0,
		type: "Static",
		args: [COLLIDER_W, COLLIDER_H, COLLIDER_D],
		position: [position[0], position[1] + COLLIDER_H / 2, position[2]],
		rotation: rotation ?? [0, 0, 0],
	}));

	return (
		<group>
			{/* Invisible collider mesh */}
			<mesh ref={colliderRef} visible={false}>
				<boxGeometry args={[COLLIDER_W, COLLIDER_H, COLLIDER_D]} />
			</mesh>
			<primitive object={bee.scene} position={position} rotation={rotation} scale={BEE_SCALE} />
		</group>
	);
}

useGLTF.preload(BEE_URL);
